/* HTB03 nativefinal v6 behavior parity 2026-06-11: exact source date replacement + product-intro sticky trigger */
(function(){
  var ROOT_ID='htb03-nativefinal';
  var INTRO_SELECTOR='#htb03nf-itksswy';
  var INTRO_TEXT='INTRODUCING THE DEVICE BUILT FOR THE CHAIR-LOCK HIP CYCLE';
  function ready(fn){ if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fn,{once:true});} else fn(); }
  function root(){ return document.getElementById(ROOT_ID); }
  function norm(s){ return (s||'').replace(/\s+/g,' ').trim(); }
  function suffix(n){return (n%10==1&&n%100!=11)?'st':(n%10==2&&n%100!=12)?'nd':(n%10==3&&n%100!=13)?'rd':'th';}
  function sourcePublishedDate(){
    var d=new Date(); d.setDate(d.getDate()-2);
    var days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return days[d.getDay()]+' . '+months[d.getMonth()]+' . '+d.getDate()+' '+suffix(d.getDate())+' , '+d.getFullYear()+' | 11:11 am EST';
  }
  function applySourceDate(r){
    // Exact iframe source behavior, scoped to native root: replace the static article publish date with local date minus 2 days.
    var txt=sourcePublishedDate();
    r.innerHTML=r.innerHTML.replace(/[A-Z][a-z]{2}\s*\.\s*[A-Z][a-z]{2}\s*\.\s*\d{1,2}\s*(?:st|nd|rd|th)\s*,\s*20\d{2}\s*\|\s*11:11\s*am\s*EST/g, txt);
  }
  function findIntro(r){
    var direct=r.querySelector(INTRO_SELECTOR);
    if(direct && norm(direct.textContent).indexOf(INTRO_TEXT)!==-1) return direct;
    var nodes=r.querySelectorAll('h1,h2,h3,h4,div,p,span');
    for(var i=0;i<nodes.length;i++){
      if(norm(nodes[i].textContent)===INTRO_TEXT || norm(nodes[i].textContent).indexOf(INTRO_TEXT)!==-1) return nodes[i];
    }
    return null;
  }
  function bindSticky(r){
    var sticky=r.querySelector('.htb03nf-sticky, #htb03nf-ix4a36-4-5');
    if(!sticky) return;
    var trigger=findIntro(r);
    function setVisible(v){ r.classList.toggle('htb03nf-sticky-visible', !!v); sticky.setAttribute('aria-hidden', v?'false':'true'); }
    function update(){
      if(!trigger){ setVisible(window.scrollY>700); return; }
      var rect=trigger.getBoundingClientRect();
      // Reveal only when product-introduction section reaches viewport, not at generic early scroll depth.
      setVisible(rect.top <= window.innerHeight && rect.bottom >= 0 || rect.top < 0);
    }
    setVisible(false); update();
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    if('IntersectionObserver' in window && trigger){
      var io=new IntersectionObserver(update,{root:null,threshold:[0,0.01],rootMargin:'0px 0px 0px 0px'});
      io.observe(trigger);
    }
  }
  ready(function(){ var r=root(); if(!r) return; applySourceDate(r); bindSticky(r); });
})();
